import { RowData, Table, TableFeature } from "@tanstack/react-table";
import { ServerSideRowSelection, ServerSideRowSelectionAllRowKey } from "./ServerSideRowSelection";

export interface RowSelectionExtInstance {
  getSelectedRowCount: () => number;
}

declare module "@tanstack/react-table" { // or whatever framework adapter you are using
  interface Table<TData extends RowData> extends RowSelectionExtInstance {}
}

export const RowSelectionExt: TableFeature = {
  createTable: <TData extends RowData>(table: Table<TData>): void => {
    table.getSelectedRowCount = () => {
      if (table._features.includes(ServerSideRowSelection)) {
        const { rowSelection } = table.getState();
        const allRowCount = table.getRowCount();

        const totalSelected = Object.entries(rowSelection ?? {})
          .filter(([ key, value ]) => key !== ServerSideRowSelectionAllRowKey)
          .filter(([ key, value ]) => value === true)
          .length;

        const totalUnselected = Object.entries(rowSelection ?? {})
          .filter(([ key, value ]) => key !== ServerSideRowSelectionAllRowKey)
          .filter(([ key, value ]) => value === false)
          .length;

        if (rowSelection[ServerSideRowSelectionAllRowKey]) {
          return allRowCount - totalUnselected;
        }
        else {
          return totalSelected;
        }
      }

      else  {
        return Object.keys(table.getState().rowSelection).length;
      }
    };
  },
};
